import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Space, Layout, Button, Typography } from "antd";
import { useTranslation } from "react-i18next";
import moment from "moment";

// redux & query
import { GetUrlParam } from "Utility/hooks/url";
import { setDeviceId, setTicketData } from "./goSlice";
import { useAppDispatch, useAppSelector } from "store/hook";
import { useGetTicketDetails } from "./queries";
import { useSetting } from "Components/Header/queries";

// styles
import headerStyles from "Components/Header/header.module.scss";
import styles from "./style.module.scss";

// components & Utils
import GoMap from "./Components/GoMap";
import Profile from "./Components/GoTicket/Profile";
import Filter from "./Components/GoTicket/Filter";
import WrongPage from "Pages/WrongPage";
import GoDeviceEdit from "./Components/GoTicket/Edit";
import GoDevicesData from "./Components/GoTicket/Data";
import { TimestampToDateOnly } from "Utility/Fetch";

// imagesimage/CompanyMainLogo.png
import CompanyMainLogo from "../../image/CompanyMainLogo.png";
import LoginLogo from "image/LoginLogo.png";

function Go() {
  const { Header: AntdHeader } = Layout;
  const { ticket } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const [lang, setLang] = useState("zh-TW");
  const { ticketVisible, record, ticketList } = useAppSelector((state) => state.goPage);
  const { stateCid, level, loginCid, time_zone } = useAppSelector((state) => state.global);
  const { isLoading, isSuccess, data } = useGetTicketDetails(ticket);

  function detectDeviceType() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /android|webos|iphone|ipad|ipod|blackberry|windows phone/.test(userAgent);

    if (isMobile) {
      return "mobile";
    } else {
      return "desktop";
    }
  }
  const deviceType = detectDeviceType();

  useEffect(() => {
    i18n.changeLanguage(data?.ticket_inf?.language);
  }, [data]);

  useEffect(() => {
    dispatch(setTicketData(data));
  }, [data]);

  let solvedNum = 0;
  for (const property in data?.ticket_inf?.fix_issue_report) {
    if (data?.ticket_inf?.fix_issue_report?.[property]?.issue_report?.solve === true) solvedNum++;
  }

  if (isSuccess) {
    dispatch(setTicketData(data));
  } else {
    return <WrongPage />;
  }

  return (
    <>
      {data && (
        <>
          {/* <AntdHeader className={headerStyles.goAntdHeader} hidden={true}> */}
          {/* 工單頁面 osmartGO page ：先到 /maintenance 點擊工單超連結 */}
          <AntdHeader className={headerStyles.goAntdHeader}>
            <header className={headerStyles.goHeader}>
              <Space size={1}>
                <img alt="" src={CompanyMainLogo} />
              </Space>
              <Space align="center" direction="horizontal" size={30} className={headerStyles.logoSpace}>
                <div>
                  <img alt="" src={LoginLogo} className={headerStyles.logoImg} />
                </div>
                <div className={headerStyles.goHeaderText}>
                  <div className={headerStyles.text}>
                    {t("ISMS.TicketNo")}: {data?.ticket_inf?.ticket?.slice(0, 14)}
                  </div>
                  <div className={headerStyles.text}>
                    {t("ISMS.Expiration")}: {TimestampToDateOnly(data?.ticket_inf?.expire_utc * 1000, time_zone)}
                  </div>
                  <div className={headerStyles.text}>
                    {t("ISMS.Progress")}:{" "}
                    {`${data?.ticket_inf?.progress?.new?.done + data?.ticket_inf?.progress?.fix?.done}/${
                      data?.ticket_inf?.progress?.new?.total + data?.ticket_inf?.progress?.fix?.total
                    }`}
                  </div>
                </div>
                {/* <div style={{ width: "50px", flex: "box" }}>
                  {lang === "zh-TW" ? (
                    <Button
                      onClick={() => {
                        i18n.changeLanguage("en");
                        setLang("en");
                      }}
                    >
                      EN
                    </Button>
                  ) : (
                    <Button
                      onClick={() => {
                        i18n.changeLanguage("zh-TW");
                        setLang("zh-TW");
                      }}
                    >
                      ZH
                    </Button>
                  )}
                </div> */}
              </Space>
            </header>
          </AntdHeader>
          {ticketVisible ? (
            <GoDeviceEdit />
          ) : (
            <>
              {deviceType === "mobile" && <Filter />}
              {deviceType === "mobile" && <GoMap />}
              {deviceType === "mobile" && <GoDevicesData />}
              {deviceType === "desktop" && <Profile />}
            </>
          )}
        </>
      )}
    </>
  );
}

export default Go;
